module.exports = __webpack_public_path__ + "img/bg1.62efb5aa.png";